import { IFile } from '../types'

export abstract class FileFormatter {
  static size(file: IFile): {
    size: number
    unit: string
    value: string
  } {
    const bytes = file.size
    const units = ['B', 'KB', 'MB', 'GB', 'TB']

    let value = bytes
    let unit = 0

    while (value >= 1024 && unit < units.length) {
      value /= 1024
      unit++
    }

    return {
      size: Math.round(value * 100) / 100,
      unit: units[unit],
      value: `${Math.round(value * 100) / 100} ${units[unit]}`
    }
  }
}
